import { render } from "./Polycom.vue?vue&type=template&id=4d9fc767"
import script from "./Polycom.vue?vue&type=script&lang=ts"
export * from "./Polycom.vue?vue&type=script&lang=ts"
script.render = render

export default script